// extracted by mini-css-extract-plugin
module.exports = {"rating":"commentForm_rating__3lYNg"};